/* eslint-disable react/no-unstable-nested-components */


/* eslint-disable react-native/no-inline-styles */

import React, { useEffect, useState } from 'react';
import { FlatList, InteractionManager, Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Divider, List, Menu } from 'react-native-paper';
import * as BluetoothPrintService from '../services/BluetoothPrintService';
import { setPaperSize } from '../store/bluetooth.slice';
import * as storage from '../services/storage';
import environment from '../environment';

function BluetoothPrinter({ navigation }) {
    const dispatch = useDispatch();
    const bluetooth_devices = useSelector((state) => state.bluetoothPrinter?.bluetooth_devices);
    const selected_bluetooth_device = useSelector((state) => state.bluetoothPrinter?.selected_bluetooth_device);
    const paper_size = useSelector((state) => state.bluetoothPrinter?.paper_size);
    const [interactionCompleted, setIntersectionCompleted] = useState(false);
    const [visible, setVisible] = useState(false);
    const openMenu = () => setVisible(true);
    const closeMenu = () => setVisible(false);

    useEffect(() => {
        const task = InteractionManager.runAfterInteractions(async () => {
            setIntersectionCompleted(true);
        });
        return () => {
            task.cancel();
        };
    }, []);

    useEffect(() => {
        if (interactionCompleted && Platform.OS === 'android') {
            BluetoothPrintService?.checkPrinterState({ loader: true });
        }
    }, [interactionCompleted]);

    const renderDevice = ({ item }) => {
        const isConnected = selected_bluetooth_device === item?.address;
        return (<List.Item
            title={item?.name || item?.address}
            right={props => <Button mode="text" onPress={() => isConnected ? BluetoothPrintService?.unPairBluetoothDevice({ address: item?.address, loader: true }) : BluetoothPrintService?.connectBluetoothDevice({ address: item?.address, loader: true })}>
                {isConnected ? 'Disconnect' : 'Connect'}
            </Button>}
        />);
    };


    const setPaperSizeHandler = (size) => {
        dispatch(setPaperSize(size));
        storage.storeData('paper_size', size);
        closeMenu();
    };

    const ListFooterComponent = () => {
        return (
            <View>
                <Divider />
                <List.Item
                    title={'Select Paper Size'}
                    onPress={openMenu}
                    right={props => (
                        <Menu
                            visible={visible}
                            onDismiss={closeMenu}
                            anchor={<Button onPress={openMenu}>{paper_size || 'Select'}</Button>}>
                            <Menu.Item onPress={() => setPaperSizeHandler('80mm')} title="80mm" />
                            <Menu.Item onPress={() => setPaperSizeHandler('58mm')} title="58mm" />
                        </Menu>
                    )}
                />
                {bluetooth_devices.length > 0 && selected_bluetooth_device && (<View>
                    <Button mode="contained" onPress={BluetoothPrintService?.testPrint} style={{ margin: 6 }}>Test Print</Button>
                    {environment.ENV !== 'production' && <Button mode="contained" onPress={() => BluetoothPrintService.testOrderPrint()} style={{ margin: 6 }}>Test Order Print</Button>}
                </View>)}
            </View>
        );
    };

    return (
        <SafeAreaView edges={['bottom']} style={styles.container}>
            {interactionCompleted &&
                <React.Fragment>
                    <View style={styles.mainContainer}>
                        <List.Item
                            title={'Devices'}
                            right={props => <Button icon="refresh" mode="text" onPress={() => BluetoothPrintService?.checkPrinterState({ loader: true })}>
                                Refresh
                            </Button>}
                        />
                        <Divider />
                        <FlatList
                            data={bluetooth_devices}
                            renderItem={renderDevice}
                            keyExtractor={(item, index) => (index).toString()}
                            ItemSeparatorComponent={<Divider style={{ backgroundColor: '#dddddd' }} />}
                            ListFooterComponent={ListFooterComponent()}
                        />
                    </View>
                </React.Fragment>
            }
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f1f1f3',
    },
    mainContainer: {
        flex: 1,
        marginVertical: 8,
    },
});

export default BluetoothPrinter;
